import { ComponentBase } from "@abstracts/component-base";
import { Component, Inject, Injector, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { MessageService } from "@services/message/message.service";

@Component({
  selector: 'app-dialog',
  template: ''
})
export abstract class AbstractDialogContent extends ComponentBase implements OnInit {

  @Inject(Router)
  public router: Router;

  @Inject(MessageService)
  public messageService: MessageService;

  constructor(public activeModal: NgbActiveModal, injector: Injector) {
    super(injector);
    this.router = injector.get(Router);
    this.messageService = injector.get(MessageService);
  }

  public onConfirmClick(): void {
    this.activeModal.close();
  }

  public onCancelClick(): void {
    this.activeModal.close();
  }
}
